/**
 * Double Row Template
 *
 * Two rows of box units sharing a spine wall (back-to-back, duplex-style).
 * Supports symmetric mode (both rows identical) and custom mode (independent config).
 */

import { Layers } from 'lucide-react'
import type { BuildingTemplate } from '../types'
import type { DoubleRowParams } from './params'
import { doubleRowParamsSchema, DEFAULT_DOUBLE_ROW_VALUES } from './params'
import { generateBuilding, generateUnits } from './generate'

/**
 * Double Row Template definition
 *
 * Creates buildings with two rows of units sharing a central spine wall.
 * - Row A faces north (primary doors on north wall)
 * - Row B faces south (primary doors on south wall)
 * - Shared spine wall between rows (can have pass-through doors)
 */
export const DoubleRowTemplate: BuildingTemplate<DoubleRowParams> = {
  id: 'double_row',
  name: 'Double Row (Back-to-Back)',
  description: 'Two rows sharing a spine wall, duplex-style.',
  icon: Layers,
  buildingType: 'box_hangar_double_row',
  generateBuilding,
  generateUnits,
  formSchema: doubleRowParamsSchema,
  defaultValues: DEFAULT_DOUBLE_ROW_VALUES,
}

// Re-export types and utilities
export * from './params'
export * from './generate'
export * from './edges'
